var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"mainback",attrs:{"src":"https://img.1234567.com.cn/libs/repository/bg.png"}})])}]

export { render, staticRenderFns }